import { Component, h } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'

interface Props {
  title: string
  amount: number
  onChange: (state: {title: string, amount: number}) => void
}

interface State {
  title: string
  amount: number
}

export class BadgesConfigurator extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      title: props.title,
      amount: props.amount
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeAmount = this.onChangeAmount.bind(this)
  }
  
  onChangeTitle (newTitle: string) {
    this.setState({
      title: newTitle
    }, () => this.notifyChanges())
  }

  onChangeAmount (newAmount: number) {
    this.setState({
      amount: newAmount
    }, () => this.notifyChanges())
  }

  notifyChanges () {
    this.props.onChange(this.state)
  }

  render (props: Props, {title, amount} : State) {
    return (
      <div class='badges-widget__configurator'>
        <InputGroup
          title='Title'
          type='text'
          qaClasses='qa-badges-widget__title'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />  
        <InputGroup
          title='Amount of users'
          type='number'
          qaClasses='qa-badges-widget__amount'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeAmount(parseInt(e.target.value, 10)) }}
          value={amount}
          min={1} />
      </div>
    )
  }
}

export default BadgesConfigurator
